import { useTranslation } from 'react-i18next'

const TYPE_ICON: Record<string, string> = {
  organization: 'mdi-domain',
  refuge: 'mdi-home-variant-outline',
  camping: 'mdi-tent',
  accommodation: 'mdi-bed-outline',
  poi: 'mdi-map-marker-outline',
}

export function TypeIcon({ type }: { type: string }) {
  const { t } = useTranslation('gestion')
  return (
    <span
      className={`mdi ${TYPE_ICON[type] ?? 'mdi-map-marker-outline'} g-type-icon g-type-icon--${type}`}
      title={t(`types.${type}`, { defaultValue: type })}
      aria-label={t(`types.${type}`, { defaultValue: type })}
    />
  )
}

export function StatusPill({ status }: { status: string }) {
  const { t } = useTranslation('gestion')
  return <span className={`g-badge g-badge--${status}`}>{t(`statuts.${status}`, { defaultValue: status })}</span>
}
